import { render, staticRenderFns } from "./WorkflowIcon.vue?vue&type=template&id=3acc776e&scoped=true"
import script from "./WorkflowIcon.vue?vue&type=script&lang=js"
export * from "./WorkflowIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acc776e",
  null
  
)

export default component.exports